export const iconFontAwesomeTravelHotelJetFighter = (
	<i className="fa-solid fa-jet-fighter"></i>
);
